export const integrations = {
	integrations: "Intégrations",
	integrationsDescription:
		"Accédez aux données d'opération via l'API Zig : boutique, ventes, fiscales, bonus, recharges et plus.",
	createDrawer: {
		addPlaces: "Lier des places",
		addPlacesDescription: "Sélectionnez les places que vous souhaitez lier à ce token.",
		selectPlaces: "Sélectionner les places",
		selectAll: "Tout sélectionner",
		generateTokenMessage:
			"Ce token sera généré et lié à tous les places sélectionnés ({{count}}). Il pourra être utilisé pour authentifier les intégrations avec l'API Zig uniquement dans ces places. Souhaitez-vous continuer ?",
		generateTokenConfirm: "Générer le token et lier aux places",
		cancelTokenMessage:
			"En annulant, le token ne sera pas créé et la sélection des places sera abandonnée. Souhaitez-vous continuer quand même ?",
		cancelToken: "Annuler le token",
	},
	token: "Token",
	createToken: "Générer un token",
	techDocumentation: "Documentation technique",
	searchPlaceholder: "Rechercher par ID de place",
	noContentTitle: "Rien ici pour le moment",
	noContentDescription:
		"Générez un token pour intégrer des systèmes externes avec l'API Zig. Copiez et utilisez-le pour l'authentification.",
	noDataTitle: "Nous n'avons pas trouvé ce que vous cherchez",
	noDataDescription: "Le place n'a pas été trouvé.",
	generatedBy: "Généré par | ",
	generatedByDate: " le ",
	generatedByTime: " à ",
	viewLinkedPlaces: "Voir les places liés",
	linkedPlaces: "Places liés",
	copyToken: "Copier le token",
	copyTokenButtonSuccess: "Copié",
	copyTokenTooltip: "Copier le token complet pour l'authentification via l'API",
	copyTokenSuccess: "Le code du token a été copié dans le presse-papiers",
	deleteToken: "Supprimer le token",
	deleteTokenConfirm: "Supprimer le token",
	deleteTokenConfirmMessage:
		"En supprimant ce token, cela pourrait affecter les intégrations en cours de tous les places qui lui sont liés. Souhaitez-vous continuer quand même ?",
	successCreateToken: "Token créé avec succès",
	successDeleteToken: "Token supprimé avec succès",
	alertTitle:
		"Le token accorde un accès complet à l'API Zig. Utilisez-le uniquement dans des intégrations sécurisées.",
	alertDescription: "Une fois créé, il restera actif jusqu'à ce qu'il soit supprimé.",
	tokenListTitle: "Token API",
	orgInfo: "Réseau | ",
};
